module.exports = __webpack_public_path__ + "img/program-lounge.c2b51e68.jpg";